var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapse-btn",on:{"click":function($event){return _vm.$emit('input', !_vm.value)}}},[_c('span',[_vm._v(_vm._s(_vm.value ? '收起' : '展开'))]),_c('i',{staticClass:"el-icon-arrow-down",class:{ active: _vm.value }})])
}
var staticRenderFns = []

export { render, staticRenderFns }